import { IFlow } from '_/features/flows/common/types/flow.types';
import usePublicToken from '_/hooks/usePublicToken';
import { IDeliveryStats } from '_/types/deliveries/delivery.types';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import React, { ReactElement } from 'react';

import DeliveryGridItem from './components/DeliveryGridItem';
import DeliverySummaryFlowInfo from './components/DeliverySummaryFlowInfo';
import DeliveryInfoCard from './DeliveryInfoCard';
import DeliverySummaryHeader from './DeliverySummaryHeader';
import classes from './DeliverySummaryItem.module.css';

interface DeliverySummaryItemProps {
  delivery: IDeliveryStats;
  flow?: IFlow;
  showDrilldownButton?: boolean;
  id?: string;
  linkTo?: string;
}

const DeliverySummaryItem = ({ delivery, flow, showDrilldownButton = true, linkTo }: DeliverySummaryItemProps): ReactElement => {
  const { token } = usePublicToken();

  return (
    <div className={classes.flexColumn}>
      <div className={classes.widget}>
        <Row gutter={24} className={classes.dataContainer}>
          <Col span={18} className={classes.containerMargin}>
            <DeliverySummaryHeader delivery={delivery!} flow={flow} linkTo={linkTo} />
            <DeliveryGridItem delivery={delivery} flow={flow!} />
          </Col>
          <Col span={6} className={classes.infoContainer}>
            <DeliveryInfoCard delivery={delivery!} showDrilldownButton={showDrilldownButton} selectedFlow={flow} />
          </Col>
        </Row>
      </div>
      {!token && !showDrilldownButton && <DeliverySummaryFlowInfo />}
    </div>
  );
};

export default DeliverySummaryItem;
